import { useEffect, useMemo } from "react"
import { Radio } from "antd"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faDiamondTurnRight } from "@fortawesome/free-solid-svg-icons"
import PageHeader from "../../components/PageHeader"
import TransportList from "../../components/TransportList"
import Disclaimer from "../../components/Disclaimer"
import GeneralHelper from "../../helpers/general"
import AnalyticsHelper from "../../helpers/analytics"
import "../../components/Filter/Filter.less"
import "./ToHkustPage.less"

const ToHkustPage = (props) => {
    const { history, match, pageProps, getLocations, getLocationEta, resetMeta } = props
    const { locations } = pageProps

    const slug = match?.params?.slug

    useEffect(() => {
        getLocations()
        return () => resetMeta()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const options = useMemo(
        () => (locations || []).map(l => ({ label: l.name, value: l.slug })),
        [locations]
    )

    // default to the first location when none selected
    useEffect(() => {
        if (!options.length) return
        if (!options.some(o => o.value === slug)) {
            history.replace(`/to-hkust/locations/${options[0].value}`)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [options, slug])

    // fetch ETA + poll every 10s
    useEffect(() => {
        if (!slug || !options.some(o => o.value === slug)) return

        const fetchEta = () => getLocationEta(GeneralHelper.objectToQueryString({ slug }))
        fetchEta()
        const interval = setInterval(fetchEta, 10000)
        return () => clearInterval(interval)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [slug, options])

    const handleSelect = (e) => {
        const value = e.target.value
        AnalyticsHelper.track('select_location', {
            direction: 'to_hkust',
            slug: value,
            name: options.find(o => o.value === value)?.label
        })
        history.push(`/to-hkust/locations/${value}`)
    }

    const handleReload = () => {
        AnalyticsHelper.track('reload_eta', { section: 'to_hkust', slug })
        if (slug && options.some(o => o.value === slug)) {
            getLocationEta(GeneralHelper.objectToQueryString({ slug }))
        }
    }

    return (
        <div className="container">
            <PageHeader icon={<FontAwesomeIcon icon={faDiamondTurnRight} />} title="To HKUST" onReload={handleReload} />

            <div className="location-grid">
                <Radio.Group
                    block
                    options={options}
                    value={slug}
                    optionType="button"
                    buttonStyle="solid"
                    onChange={handleSelect}
                    className="filter-options"
                />
            </div>

            <TransportList style={{ marginBlockStart: 24 }} props={props} />

            <Disclaimer />
        </div>
    )
}

export default ToHkustPage
